import schema from './schema'

export type Theme = typeof schema.data.default

export default schema
export * from './resources'
